import React from "react"

const StarIcons = ({ reviewAvg, className }) => {
  const filled = [1, 2, 3, 4, 5].filter((i) => i <= parseInt(reviewAvg, 10))
  const empty = [1, 2, 3, 4, 5].filter((i) => i > parseInt(reviewAvg, 10))

  return (
    <>
      {filled.map((s) => (
        <svg
          key={`star-filled-${s}`}
          xmlns="http://www.w3.org/2000/svg"
          className={`${className} block shrink-0 text-yellow-400`}
          fill="#fef3c7"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          />
        </svg>
      ))}
      {empty.map((s) => (
        <svg
          key={`star-empty-${s}`}
          xmlns="http://www.w3.org/2000/svg"
          className={`${className} block shrink-0 text-gray-200`}
          fill="#fff"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          />
        </svg>
      ))}
    </>
  )
}

// draws a community's star rating and count
const CommunityStarRating = ({
  community,
  starHeight, // defaults to 5 (legacy tailwind class suffix)
  compact = false,
}) => {
  if (!community || community.reviewCount === null || community.reviewAvg === null) {
    return null
  }

  const avg = parseFloat(community.reviewAvg, 10)
  if (Number.isNaN(avg)) {
    return null
  }

  const reviewCount = parseInt(community.reviewCount, 10)
  if (Number.isNaN(reviewCount) || reviewCount < 1) {
    return null
  }

  const avgDisplay = avg.toFixed(1)
  const countLabel =
    reviewCount === 1 ? "1 review" : `${reviewCount} reviews`
  const ariaLabel = `Rated ${avgDisplay} out of 5 from ${countLabel}`

  if (compact) {
    return (
      <div className="inline-flex shrink-0 items-center gap-1" aria-label={ariaLabel}>
        <span className="inline-flex items-center gap-px" aria-hidden="true">
          <StarIcons reviewAvg={community.reviewAvg} className="h-3.5 w-3.5" />
        </span>
        <span
          className="text-xs tabular-nums leading-none text-gray-500"
          aria-hidden="true"
        >
          ({reviewCount})
        </span>
      </div>
    )
  }

  const starSize = `h-${starHeight || "5"} w-${starHeight || "5"}`
  const textClass = "text-sm tabular-nums leading-none text-gray-500"

  return (
    <div className="inline-flex shrink-0 items-center gap-1" aria-label={ariaLabel}>
      <span className={textClass} aria-hidden="true">
        {avgDisplay} rating
      </span>
      <span className="inline-flex items-center gap-px" aria-hidden="true">
        <StarIcons reviewAvg={community.reviewAvg} className={starSize} />
      </span>
      <span className={textClass} aria-hidden="true">
        {countLabel}
      </span>
    </div>
  )
}

export { StarIcons }
export default CommunityStarRating
